import { createFeatureSelector, createSelector } from '@ngrx/store';
import { PromocodeState } from '../reducers/promocode.reducer';

export const getPromocodeState =
  createFeatureSelector<PromocodeState>('promocode');

export const getPromocode = createSelector(
  getPromocodeState,
  (state: PromocodeState) => state.value,
);

export const getPromocodeUsage = createSelector(
  getPromocodeState,
  (state: PromocodeState) => state.usage,
);

export const getPromocodeError = createSelector(
  getPromocodeState,
  (state: PromocodeState) => state.post.error,
);

export const getPromocodeLoadingState = createSelector(
  getPromocodeState,
  (state: PromocodeState) => state.post.loading,
);
